import React, { useContext } from 'react';
import { Link, classNamesFunction, useTheme, mergeStyles } from '@fluentui/react';
import { IHelpStyles, IHelpProps } from './Help.types';
import { helpStyles } from './Help.styles';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';

// previous url: http://g.microsoftonline.com/1AX00en/170
const TERMS_OF_SERVICE_URL = 'https://azure.microsoft.com/support/legal/';
const PRIVACY_URL = 'https://go.microsoft.com/fwlink/?LinkId=521839';
const FRENCH_ACCESSIBILITY_URL = 'https://www.microsoft.com/fr-fr/accessibility/accessibilite/declarations';
const ITALY_ACCESSIBILITY_URL = 'https://www.microsoft.com/it-it/accessibility/declarations';

const getClassNames = classNamesFunction<IHelpProps, IHelpStyles>();

export const HelpPanelContent: React.FC<IHelpProps> = props => {
  const theme = useTheme();
  const linkClass = mergeStyles(helpStyles.link, { fontSize: theme.fonts.medium.fontSize });
  const classNames = getClassNames(helpStyles);
  const context = useContext(SuiteHeaderContext);
  const {
    helpPanelHeaderText,
    helpPanelTermsOfUseLink,
    helpPanelPrivacyLink,
    accessibilityLink: accessibilityLinkText
  } = context.localizationMap;
  const { helpLink, culture } = props;
  const accessibilityLink = getAccessibilityLink(culture);

  return (
    <div>
      <div className={classNames.main}>
        <div className={linkClass}>
          <Link href={helpLink} target={'_blank'} styles={{ root: { textDecoration: 'underline' } }}>
            {helpPanelHeaderText}
          </Link>
        </div>
        <div className={linkClass}>
          <Link href={PRIVACY_URL} target={'_blank'} styles={{ root: { textDecoration: 'underline' } }}>
            {helpPanelPrivacyLink}
          </Link>
        </div>
        <div className={linkClass}>
          <Link href={TERMS_OF_SERVICE_URL} target={'_blank'} styles={{ root: { textDecoration: 'underline' } }}>
            {helpPanelTermsOfUseLink}
          </Link>
        </div>
        {accessibilityLink && (
          <div className={linkClass}>
            <Link href={accessibilityLink} target={'_blank'} styles={{ root: { textDecoration: 'underline' } }}>
              {accessibilityLinkText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

function getAccessibilityLink(culture: string) {
  switch (culture.toLocaleLowerCase()) {
    case 'fr-fr':
      return FRENCH_ACCESSIBILITY_URL;
    case 'it-it':
      return ITALY_ACCESSIBILITY_URL;
    default:
      return null;
  }
}
